module.exports = __webpack_public_path__ + "static/media/graystar.75de76e8.svg";